<template>
  <div class="year20">
    <div class="banner">
      <el-carousel trigger="click" indicator-position="none" autoplay :height="bannerCarouselHeight+'px'" >   
        <el-carousel-item v-for="(item,index) in bannerLists" :key="index">
            <img :src="item.picturePath" ref="bannerCarousel"/>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="container">

      <div class="headling ">
        <h3>{{$t("year20.vedio.headling")}}</h3>
      </div>

      <video width="100%" height="auto" preload="metadata"  muted playsinline controls style="background:#a01323;background-position: center; " poster="../../assets/img/year20/video_post.jpg">
        <source src="../../assets/img/year20/year20.mp4" type="video/mp4" >
      </video>

      <div class="headling ">
        <h3>{{$t("year20.history.headling")}}</h3>
      </div>
      <!-- <div class="history hidden-xs-only"  @scroll="historyScroll">
        <el-row :gutter="60">
          <el-col :span="8" :xs="24" >
            <div class="pic">
              <img src="../../assets/img/about/dqc.png" />
            </div>
          </el-col>
          <el-col :span="16" :xs="24">
            <div class="swiper-wrap">
              <swiper :options="swiperOption"  class="history-swiper" @slideChange="slideChange" ref="indexSwiper">
                <swiper-slide class="swiper-slide" v-for="(item,index) in history" :key="index">
                  <h2>{{item.startYear.slice(0,4)}}</h2>
                  <p>{{item.companyContent}}</p>
                </swiper-slide>
                <div class="swiper-scrollbar" slot="scrollbar"></div>
              </swiper>
              <div class="year" v-if="history[yearIndex+2] && history[yearIndex]">{{history[yearIndex+2].startYear.slice(0,4)}} — {{history[yearIndex].startYear.slice(0,4)}}</div>
            </div>
          </el-col>
        </el-row>
      </div> -->
      <div class="history hidden-xs-only" id="history">
        <el-tabs v-model="activeName"   tab-position="bottom" :stretch="true">
          <el-tab-pane v-for="(i,index) in Math.ceil(history.length/3) " :key="index"  :name="'pane'+index">
            <template #label>
              <span >{{ history[index*3].startYear.slice(0,4) }} <span>——</span> {{ history[index*3+2] ? history[index*3+2].startYear.slice(0,4): history[index*3+1] ? history[index*3+1].startYear.slice(0,4) : history[index*3+0].startYear.slice(0,4)}}</span>
            </template>

            <el-row :gutter="60">
              <el-col :span="12"  >
                <div class="pic">
                  <img :src="require(`../../assets/img/about/pane${ index+1 }.jpg`)" />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="box-wrap">
                  <div class="box" v-for="item in history.slice(index*3,index*3+3)" :key="item.companyContentNo">
                    <h2>{{item.startYear.slice(0,4)}}</h2>
                    <p>{{item.companyContent}}</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="history hidden-sm-and-up">
        <el-timeline>
          <el-timeline-item
            v-for="(item,index) in history"
            :key="index"
            :timestamp="item.companyContent"
            color="#0054a7">
            {{ item.startYear.slice(0,4) }}
          </el-timeline-item>
        </el-timeline>
      </div>
        
      <div class="headling ">
        <h3>{{$t("year20.news.headling")}}</h3>
      </div>

      <div class="news hidden-xs-only">
        <el-row v-for="(item,index) in newsList" :key="index" >
          <template v-if="index%2==0">
            <el-col :span="14" :xs="24" >
              <div class="pic">
                <img :src="item.mainPicUrl" />
              </div>
            </el-col>
            <el-col :span="10" :xs="24" >
              <div class="box">
                <h4>{{ item.title }}</h4>
                <div class="des">{{ item.smallContent}}</div>
                <div>
                  <el-button type="primary" plain @click="toDetail(item)">{{$t("home.product.button")}}</el-button>
                </div>
              </div>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="10" :xs="24" >
              <div class="box">
                <h4>{{ item.title }}</h4>
                <div class="des">{{ item.smallContent}}</div>
                <div>
                  <el-button type="primary" plain @click="toDetail(item)">{{$t("home.product.button")}}</el-button>
                </div>
              </div>
            </el-col>
            <el-col :span="14" :xs="24" >
              <div class="pic">
                <img :src="item.mainPicUrl" />
              </div>
            </el-col>
          </template>
        </el-row>
      </div>

      <div class="news hidden-sm-and-up">
        <el-row v-for="(item,index) in newsList" :key="index" >
          <el-col :span="14" :xs="24" >
            <div class="pic">
              <img :src="item.mainPicUrl" />
            </div>
          </el-col>
          <el-col :span="10" :xs="24" >
            <div class="box">
              <h4>{{ item.title }}</h4>
              <div class="des">{{ item.smallContent}}</div>
              <div>
                <el-button type="primary" plain @click="toDetail(item)">{{$t("home.product.button")}}</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="headling ">
        <h3>{{$t("year20.employee.headling")}}</h3>
      </div>

      <div class="employee">
        <p class="description">{{$t("year20.employee.des")}}</p>
        <el-row :gutter="20" class="hidden-xs-only">
          <el-col :span="7" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_10.png" />
            </div>
            <div class="des">{{$t("year20.employee.title10")}}</div>
          </el-col>
          <el-col :span="10" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_20.png" />
            </div>
            <div class="des">{{$t("year20.employee.title20")}}</div>
          </el-col>
          <el-col :span="7" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_15.png" />
            </div>
            <div class="des">{{$t("year20.employee.title15")}}</div>
          </el-col>
        </el-row>

        <el-row :gutter="20" class="hidden-sm-and-up">
          <el-col :span="7" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_10.png" />
            </div>
            <div class="des">{{$t("year20.employee.title10")}}</div>
          </el-col>
          <el-col :span="7" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_15.png" />
            </div>
            <div class="des">{{$t("year20.employee.title15")}}</div>
          </el-col>
          <el-col :span="10" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_20.png" />
            </div>
            <div class="des">{{$t("year20.employee.title20")}}</div>
          </el-col>
        </el-row>
      </div>
      <!-- 
      <div class="headling ">
        <h3>{{$t("year20.bless.headling")}}</h3>
      </div>

      <div class="bless">
        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_10.png" />
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_15.png" />
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_10.png" />
            </div>
          </el-col>
          <el-col :span="12" :xs="24">
            <div class="pic">
              <img src="../../assets/img/year20/y_15.png" />
            </div>
          </el-col>
        </el-row>
      </div> -->

      <div class="headling ">
        <h3>{{$t("year20.activity.headling")}}</h3>
      </div>

      <div class="activity">
        <div v-for="(item,index) in activityList" :key="index"  class="new-des" @click="toDetail(item)">
          <img :src="item.mainPicUrl" />
          <div class="mark">
            <h2>{{ item.title }}</h2>
            <button plain>{{$t("home.product.button")}}</button>
          </div>
        </div>
      </div>
    
    </div>
    
  </div>
</template>
<script>
import { gettoppiclist } from "../../api/home"
import {getstaticcontent} from "../../api/about"
import {gettopnewlistByType} from "../../api/news"
import { mapGetters } from "vuex";
export default {
  name: "Year20",
  data() {
    return {
      bannerLists:[],
      history:[],
      yearIndex:0,
      topNum:0,
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 3, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        slidesPerGroup : 3,
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        releaseOnEdges: true,//当Swiper处于边缘位置时（第一个或最后一个slide），Swiper释放鼠标滚轮事件，鼠标可以控制页面滚动。
        height: 600, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        debugger: true,
        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          slideChange: () => {
            //let swiper = this.$refs.indexSwiper.swiper;
            //console.log(swiper.activeIndex); //滑动打印当前索引

          }
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true, // 该参数设置为true时允许拖动滚动条。
        // dragSize: 50 // 设置滚动条指示的尺寸。默认'auto': 自动，或者设置num(px)。
        },

      },
      newsList:[],
      activityList:[],
      bannerCarouselHeight:0,
      activeName: 'pane0',
    };
  },
  computed:{
    ...mapGetters(['language']),
  },
  mounted() {
    gettoppiclist (this.language, "2" ).then(res=>{
      this.bannerLists = res.data;
      this.$nextTick(()=>{
        setTimeout(()=>{
          this.bannerCarouselHeight = this.$refs.bannerCarousel[0].height;
        },100)
      })
    });
    getstaticcontent(this.language,"3").then(res=>{
      this.history = res.data;
    });
    // 20周年新闻
    gettopnewlistByType(this.language,{contentType:'4'}).then(res=>{
      this.newsList = res.data.slice(0,5);
    });
    // 20周年主题活动
    gettopnewlistByType(this.language,{contentType:'5'}).then(res=>{
      this.activityList = res.data.slice(0,5);
    });
    
  },
  methods: {
    historyScroll(e){
      this.topNum=e.target.scrollTop; 
    },
    toDetail(item) { 
      if(item.wxUrl){
        window.open(item.wxUrl,false);
      }else{
        this.$router.push({ path: `/news/detail/${item.id}` });
      }
    },
    slideChange() {
      let swiperIndex = this.$refs.indexSwiper.swiper.activeIndex;
      this.yearIndex = swiperIndex;
    },
  }
};
</script>
<style lang="scss" scoped>
$cblue: #0054a7;
.year20 {
  .banner {
      img{
        width:100%;
        height:auto;
      }
  }
  .headling{
    h3{
      margin:100px 0 50px;
      color:$cblue;
      font-size: 30px;
      font-weight: bold;
      &::after{
        content:"";
        display: block;
        width: 64px;
        height:14px;
        background:url(../../assets/img/year20/tag.png);
        background-size:100% 100%;
        margin-top:5px;
      }
    }
    
  }
  .history{
    margin-bottom:200px;
    .swiper-wrap{
      position: relative;
      padding-left:10px;
      .year{
        position: absolute;
        left:0;
        bottom:130px;
        color: #0052ac;
        font-size: 60px;
        font-weight: bold;
        transform: rotate(-90deg);
        transform-origin: left bottom;
      }
     .history-swiper {
        height: 600px; /* 设置Swiper容器的高度 */
        .swiper-slide {
          height: 200; /* 设置滑块的高度 */
          padding-right: 15px;
          box-sizing: border-box;
          p{
            text-align: justify;
          }
        }
      }
    }
    .pic{
      img{
        width:100%;
        height: 390px;
        object-fit: contain;
      }
    }
    .box-wrap{
      height:390px;
      overflow-y: auto;
      padding-right:20px;
      .box{
        margin-bottom:30px;
        h2{
          color:#0052ac;
        }
        p{
          text-align: justify;
        }
      }
    }

    ::v-deep .el-tabs__item{
      font-size: 24px;
      position: relative;
      top: 40px;
    }
    ::v-deep .el-tabs__nav-wrap{
      overflow:inherit;
    }
    ::v-deep .el-tabs__nav-scroll{
      overflow:inherit;
    }
    ::v-deep .el-tabs__nav-wrap::after{
      bottom:-40px;
    }

    /* 整个滚动条 */
    ::-webkit-scrollbar {
        /* 对应纵向滚动条的宽度 */
        width: 10px;
        /* 对应横向滚动条的宽度 */
        height: 10px;    
    }

    /* 滚动条上的滚动滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #49b1f5;
        border-radius: 32px;
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #dbeffd;
        border-radius: 32px;
    }

  }
  .news{
    .el-row{
      margin-bottom:40px;
      
      .pic{
        img{
          width:100%;
          height: 360px;
          object-fit: cover;
        }
      }
      .box{
        box-sizing: border-box;
        height: 360px;
        padding:60px 100px;
        background:#F6F6F6;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4{
          color:$cblue;
          font-weight: bold;
          font-size:22px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .des{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 2;
        }
        .el-button{
          width:140px;
        }
      }
    }
  }
  .employee{
    .description{
      padding:0 30px 50px;
      text-align: justify;
      text-indent: 2em;
    }
    .el-row{
      .el-col-7{
        transform:translateY(22%);
      }
      .des{
        text-align: center;
        font-weight: 800;
        font-size: 20px;
        margin-top:20px;
      }
    }
  }
  .bless{
    .el-col{
      margin-bottom:30px;
    }
  }
  .activity{
    .new-des {
      position: relative;
      margin-bottom:80px;
      img {
        height: 500px;
        width: 100%;
        object-fit: cover;
      }
      .mark {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        box-sizing: border-box;
        padding: 15px;
        display: flex;
        justify-content: space-between;
        h2{
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        button{
          color:#fff;
          border:1px solid #fff;
          padding:5px 20px;
          background:transparent;
          border-radius: 3px;
          font-size: 14px;
          white-space: nowrap;
          &:hover{
            background:#0052ac;
            border:1px solid #0052ac;
          }
        }
      }
    }
  }

  /* 大型屏幕(桌面) */

  @media screen and (min-width: 1400px) {
      .container {
          width: 70%;
      }
  }
  @media screen and (max-width:768px){
    .headling{
      h3{
        margin:40px 0 20px;
        color:$cblue;
        font-size: 20px;
        font-weight: bold;
        &::after{
          content:"";
          display: block;
          width: 32px;
          height:7px;
        }
      }
    }
    .history{
      margin-bottom:0;
      ::v-deep .el-timeline-item__content{
        font-size: 20px;
        color:$cblue;
        font-weight: bold;
      }
      ::v-deep .el-timeline-item__timestamp{
        font-size: 16px;
        line-height: 1.6;
      }
    }
    .news{
      .el-row{
        margin-bottom:30px;
        
        .pic{
          img{
            width:100%;
            height: 200px;
            object-fit: cover;
          }
        }
        .box{
          box-sizing: border-box;
          height: 260px;
          padding:20px;
        }
      }
    }
    .employee{
      .description{
        padding:0 0 30px;
      }
      .el-row{
        .el-col-7{
          transform:translateY(0);
        }
        .des{
          text-align: center;
          font-weight: 800;
          font-size: 20px;
          margin-top:10px;
          margin-bottom:20px;
        }
      }
      
    }
    .activity{
      .new-des {
        position: relative;
        margin-bottom:30px;
        img {
          height: 300px;
          width: 100%;
          object-fit: cover;
        }
        .mark{
          h2{
            font-size: 16px;
          }
        }
      }
    }
  }

}

</style>